import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { ServiceBannerContainer } from '../../containers/ServiceBannerContainer';
import { Layout } from '../Layout';

export const BuildersBlock: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Layout>
      <div className={styles['container']} id="developer" data-testid="BuildersBlockComponent">
        <div className={styles['header']}>
          <UIHeading1>Кто строит ЖК</UIHeading1>

          <ServiceBannerContainer type="builder" />
        </div>

        <div className={styles['builders-list']}>{children}</div>
      </div>
    </Layout>
  );
};
